import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, OnChanges, SimpleChanges } from '@angular/core';

export interface Option {
  value: any;
  label?: string;
}

@Component({
    selector: 'app-data-filter-select-search',
    changeDetection: ChangeDetectionStrategy.Default,
    templateUrl: './data-filter-select-search.component.html',
    styleUrls: ['./data-filter-select-search.component.scss'],
    standalone: false
})
export class DataFilterSelectSearchComponent implements OnInit, OnChanges {

  @Input()
  label: string;

  @Input()
  model: any;

  @Input()
  disabled = false;

  @Input()
  options: Option[] = [];

  @Output()
  modelChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.disabled && this.disabled) {
      this.model = null;
      this.change();
    }
  }

  change() {
    console.log(this.model);
    this.modelChange.emit(this.model);
  }

}
